import { useEffect, useRef, useState, useCallback } from "react";


const useSafeState = (initialState) => {
    const mountedRef = useRef(false);
    const [state, setState] = useState(initialState);

    useEffect(() => {
        mountedRef.current = true;
        return () => (mountedRef.current = false);
    }, []);

    const safeSetState = useCallback((...args) => mountedRef.current && setState(...args), []);

    return [state, safeSetState];
}

 export default useSafeState;